import React, { useEffect, useRef, useState } from "react";
import { FiUploadCloud } from "react-icons/fi";
import { CLOUDINARY_CLOUD } from "../constants/CloudinaryConstants";
import { HOST } from "../constants/HostConstants";

const UploadWidgetEdit = ({
  setUploadedItems,
  userId,
  propertyId,
  className,
}) => {
  const cloudinaryRef = useRef();
  const widgetRef = useRef();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const initWidget = async () => {
      cloudinaryRef.current = window.cloudinary;
      try {
        // Build folder path: user_{userId}/property_{propertyId} or just user_{userId}
        const folder = propertyId
          ? `user_${userId}/property_${propertyId}`
          : `user_${userId}`;

        const res = await fetch(
          `${HOST}/api/user/cloudinarySign?folder=${encodeURIComponent(folder)}`
        );
        if (!res.ok) throw new Error("sign failed");
        const sign = await res.json();
        const widgetOptions = {
          cloudName: sign.cloud || CLOUDINARY_CLOUD,
          uploadSignature: sign.signature,
          uploadSignatureTimestamp: sign.timestamp,
          apiKey: sign.api_key,
          folder: sign.folder,
          // Compression options during upload
          transformation: [
            {
              quality: "auto:good", // Automatic quality optimization
              fetch_format: "auto", // Auto-select format (AVIF, WebP, JPG, PNG)
              width: 1920, // Max width
              crop: "scale",
            },
          ],
          // Eager transformations (pre-generate optimized versions)
          eager: [
            {
              width: 600,
              height: 600,
              crop: "fill",
              gravity: "auto",
              quality: 80,
              fetch_format: "auto",
            },
          ],
        };
        if (sign.preset) widgetOptions.uploadPreset = sign.preset;
        widgetRef.current = cloudinaryRef.current.createUploadWidget(
          widgetOptions,
          function (error, result) {
            if (result && result["event"] === "success") {
              setUploadedItems((current) => [
                ...current,
                result["info"]["path"],
              ]);
            }
          }
        );
        if (mounted) setReady(true);
      } catch (err) {
if (mounted)
          setError("Unable to initialize signed upload widget. Contact admin.");
      }
    };
    if (userId) {
      initWidget();
    }
    return () => {
      mounted = false;
    };
  }, [userId, propertyId]);
  return (
    <button
      type="button"
      aria-label="Upload image"
      className={`${
        className || "absolute -top-3 -right-3"
      } flex items-center justify-center bg-white/95 border border-slate-200 shadow-md text-slate-700 rounded-full p-2 transition-all ${
        !ready
          ? "opacity-60 cursor-not-allowed"
          : "hover:scale-105 hover:cursor-pointer"
      }`}
      onClick={() => {
        if (!ready || !widgetRef.current) {
          alert(error || "Upload is not available.");
          return;
        }
        widgetRef.current.open();
      }}
    >
      <FiUploadCloud size={22} />
    </button>
  );
};

export default UploadWidgetEdit;
